export const ONBOARDING_SESSION_FLAG = 'show_platform_onboarding';
export const ONBOARDING_IN_PROGRESS_KEY = 'platform_onboarding_in_progress';
export const ONBOARDING_COMPLETED_PREFIX = 'platform_onboarding_completed_';

/** Temporary new-user flag (localStorage). Replace with backend/user-profile logic later. */
export const SIGNUP_AGENT_ONBOARDING_PENDING_KEY = 'signup_agent_onboarding_pending';
export const SIGNUP_AGENT_ONBOARDING_ANSWERS_KEY = 'signup_agent_onboarding_answers';
export const SIGNUP_AGENT_ONBOARDING_COMPLETED_PREFIX = 'signup_agent_onboarding_completed_';
export const SIGNUP_AGENT_ONBOARDING_PATH = '/app/onboarding';
